import base from "/mnt/data/b/monochrome/images/genius-inactive.svg?svg";
import { getResizer } from "svg-merge-attributes";
export default getResizer(base, "");